import React from "react";
import ReactDOM from "react-dom/client";
import { ConfigProvider } from "antd";
import zhCN from "antd/locale/zh_CN";
import dayjs from "dayjs";
import "dayjs/locale/zh-cn";
import router from "./router";
import "./index.css";
import { RouterProvider } from "react-router-dom";
import reportWebVitals from "./reportWebVitals";
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
dayjs.locale("zh-cn");
root.render(
  <React.StrictMode>
    <ConfigProvider
      locale={zhCN}
      theme={{
        components: {
          Button: {
            colorPrimary: "#1E50FF",
            colorPrimaryHover: "#426cff",
            colorLink: "#1E50FF",
            colorLinkHover: "#426cff",
          },
        },
      }}
    >
      <RouterProvider router={router} />
    </ConfigProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
